import {
  ConfirmationDialogCreatePromo,
  ManageActivitiesComponent,
} from "./../../../home/manage-activities/manage-activities.component";
import {
  Component,
  OnInit,
  Inject,
  Output,
  EventEmitter,
  ViewChildren,
  ElementRef,
  ViewChild,
} from "@angular/core";
import {
  LocalService,
  SellerService,
  Errors,
  ManagerService,
  FileService,
} from "../../../core";
import { CONSTANTS, managerApi } from "../../../config";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialog,
  MatTableDataSource,
} from "@angular/material";
import { DomSanitizer } from "@angular/platform-browser";
import { PopupMessageService } from "../../message/services/message.service";
import { WelcomepageDialogComponent } from "src/app/welcomepage-dialog/welcomepage-dialog.component";
import { ApprovaltrackerDialogComponent } from "src/app/home/manage-activities/approvaltracker-dialog/approvaltracker-dialog.component";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { DOCUMENT } from "@angular/common";
import { DownloadFileFormatDialog } from "src/app/home/manage-activities/create-promotions/create-promotions.component";
import { CashpaymentService } from "src/app/core/services/cashpayment.service";

@Component({
  selector: "app-seller-rewards-dialog",
  templateUrl: "./seller-rewards-dialog.component.html",
  styleUrls: ["./seller-rewards-dialog.component.scss"],
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class SellerRewardsDialogComponent implements OnInit {
  @Output() submitClicked = new EventEmitter<any>();
  userProfile;
  isStatic;
  selfServiceUrl = "https://www.cisco.com/go/pss";
  content;
  searchData: string = "";
  searchResult;
  regionList = [];
  months = CONSTANTS.months;
  errors: Errors = { errors: {} };
  default =
    "Manage how your Seller individuals participate in this program by turning on/off features and functionalities.";
  uploadSubmitBtn: boolean = true;
  selectedCategory: any = "";
  uploadedDocmentName;
  uploadProgressFlag: boolean = false;
  uploadedResult: any = [];
  statusHistoryList: any;
  loadStatusHistroy: boolean = false;
  signatureName: any = "";
  pamData: any = "";
  @ViewChildren("fileInput") myFileInput;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private sellerService: SellerService,
    private managerService: ManagerService,
    private sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<SellerRewardsDialogComponent>,
    private popupMessageService: PopupMessageService,
    private dialog: MatDialog,
    @Inject(DOCUMENT) private document: Document,
    private cashPaymentService: CashpaymentService,
    private fileService: FileService
  ) {}

  ngOnInit() {
    this.isStatic = this.data ? this.data : null;
    this.userProfile = LocalService.get("userProfile");
    this.content = this.data ? this.data : this.default;
    this.searchResult = this.data ? this.data.message : this.default;
    this.searchData = this.searchResult
      ? this.searchResult.searchText
      : "Enter your Sales PO Number";
    if (this.isStatic.name == "finalizeChallengePopup") {
      this.selectedCategory =
        this.isStatic.catogoriesLIst.uploadFileCategoryList[0].value;
      this.regionList = this.generateRegionUploadList(
        this.isStatic.catogoriesLIst.uploadFileCategoryList,
        this.isStatic.data.regions,
        this.isStatic.countryGroupList,
        this.isStatic.data
      );
    }

    // if(this.isStatic.name=='fileDownload'){
    //  this.selectedCategory=this.isStatic.fileData[0].category;
    //  this.onChangeCategory(this.selectedCategory)
    // }
    if (
      this.isStatic.name == "uploadDocument" ||
      this.isStatic.name == "fileDownload"
    ) {
      if (this.isStatic.fileData.attachedFiles.length == 0) {
        this.selectedCategory =
          this.isStatic.catogoriesLIst.uploadFileCategoryList[0].value;
      } else {
        this.selectedCategory =
          this.isStatic.fileData.attachedFiles[0].category;
      }

      this.regionList = this.generateRegionUploadList(
        this.isStatic.catogoriesLIst.uploadFileCategoryList,
        this.isStatic.fileData.regions,
        this.isStatic.countryGroupList,
        this.isStatic.fileData
      );

      this.onChangeCategory(this.selectedCategory);
    }

    this.getApprovalTrackerData();

    if (
      this.isStatic.name == "uploadCompletions" ||
      this.isStatic.name === "sellerCoursesInfo" ||
      this.isStatic.name === "bannerImgPreview" ||
      this.isStatic.name == "statusHistorybyPartnerLeader" ||
      this.isStatic.name === "paymentConfirmationPopup" ||
      this.isStatic.name === "showSuccessMsg"
    ) {
      this.loadCiscoStyles("client-cisco.css");
    }
    if (this.isStatic.name == "statusHistorybyPartnerLeader") {
      this.getStatusHistoryOfCashPayments();
    }
    if (
      this.userProfile.hasOwnProperty("userType") &&
      this.userProfile.userType == "PAM"
    ) {
      this.pamData = LocalService.get("pamData");
    }
  }
  sellerNoRecorFound(value) {
    this.searchResult = "";
    const queryParam = {
      searchText: value.trim(),
      companyId: this.userProfile.company.id,
    };
    this.managerService.getpoSearchResult(queryParam).subscribe((data) => {
      if (data) {
        this.searchResult = data;
      }
    });
  }
  valuechange(newValue) {
    this.searchData = "";
  }
  // Open self service url in new tab
  updateEmailService() {
    window.open(this.selfServiceUrl, "_blank");
  }

  // Formatting a date
  formatDate(date) {
    const formatDate = new Date(date.split("T")[0]);
    return `${
      this.months[formatDate.getMonth()]
    } ${formatDate.getDate()}, ${formatDate.getFullYear()}`;
  }

  setTime(date) {
    return new Date(
      new Date(date).getFullYear(),
      new Date(date).getMonth(),
      new Date(date).getDate()
    );
  }

  // Get the status of participant's courses
  getStatus(check, completedBy, creationDate, startDate) {
    var lang = localStorage.getItem("selectedLanguage");
    let value = "Open";
    if (lang == "Korean") {
      value = "열다";
    }
    if (lang == "Japanese") {
      value = "開いた";
    }
    const createdDate = this.setTime(creationDate.split("T")[0]);
    const startOn = this.setTime(startDate.split("T")[0]);
    const completeByDate = this.setTime(completedBy.split("T")[0]);
    const currentDate = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate()
    );
    const isExpired = currentDate.getTime() > completeByDate.getTime();
    const creationOn = createdDate.getTime() < startOn.getTime();
    const pending = startOn.getTime() > currentDate.getTime();
    if (check) {
      value = this.formatDate(check);
    }
    if (!check && isExpired) {
      value = "Closed";
      if (lang == "Korean") {
        value = "닫은";
      }
      if (lang == "Japanese") {
        value = "閉まっている";
      }
    }
    if (creationOn && pending) {
      value = "Pending";
      if (lang == "Korean") {
        value = "대기 중";
      }
      if (lang == "Japanese") {
        value = "保留中";
      }
    }
    return value;
  }
  getArchitecture(architecture) {
    var lang = localStorage.getItem("selectedLanguage");
    if (lang == "Korean" || lang == "Japanese") {
      if (architecture == "Collaboration") {
        if (lang == "Korean") {
          architecture = "협동";
        }
        if (lang == "Japanese") {
          architecture = "コラボレーション";
        }
      }
      if (architecture == "Security") {
        if (lang == "Korean") {
          architecture = "보안";
        }
        if (lang == "Japanese") {
          architecture = "セキュリティ";
        }
      }
      if (architecture == "Data Center") {
        if (lang == "Korean") {
          architecture = "데이터 센터";
        }
        if (lang == "Japanese") {
          architecture = "データセンター";
        }
      }
      if (architecture == "Enterprise Network") {
        if (lang == "Korean") {
          architecture = "엔터프라이즈 네트워크";
        }
        if (lang == "Japanese") {
          architecture = "エンタープライズネットワーク";
        }
      }
      if (architecture == "Wireless and Mobility") {
        if (lang == "Korean") {
          architecture = "무선 및 이동성";
        }
        if (lang == "Japanese") {
          architecture = "ワイヤレスとモビリティ";
        }
      }
      if (architecture == "Software") {
        if (lang == "Korean") {
          architecture = "소프트웨어";
        }
        if (lang == "Japanese") {
          architecture = "ソフトウェア";
        }
      }
      if (architecture == "Internet of Things") {
        if (lang == "Korean") {
          architecture = "사물 인터넷";
        }
        if (lang == "Japanese") {
          architecture = "モノのインターネット";
        }
      }
      if (architecture == "Services") {
        if (lang == "Korean") {
          architecture = "서비스";
        }
        if (lang == "Japanese") {
          architecture = "サービス";
        }
      }
    }
    return architecture;
  }
  // Split the data
  splitData(value) {
    // const newData = String(value).split('.')[0];
    const parseValue = parseFloat(value);
    const newData = parseValue.toLocaleString();
    return newData.toString();
  }

  htmlProperty(html) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  // Split html link from the data
  parseHTML(value) {
    return value.split("<")[0];
  }

  // Parse link from data
  parseLink(value) {
    return value.match(/href='([^']*)/)[1];
  }

  // Open link for take class in new tab
  viewClass(link) {
    window.open(link, "_blank");
  }

  // Get link for courses
  takeClass(link) {
    this.sellerService.getCoursesTakeClass().subscribe(
      (data) => {
        window.open(link, "_blank");
      },
      (err) => {
        this.errors = err;
      }
    );
  }

  takeQuiz(url, quizid) {
    let finalUrl = url;
    window.open(finalUrl, "_self");
  }

  prizeDrawing(ticketData) {
    ticketData.disableAutoFlag = true;
    this.submitClicked.emit(ticketData);
  }
  // provide file download option for cisco admin
  downloadFile(data) {
    window.open(data.data.url, "_blank").focus();
  }

  getFile(eve, item) {
    item.data = eve.target.files[0];
    item.showUploadBtn = true;
    item.uploadSuccess = false;
    item.flag = false;
  }

  removeFile(item) {
    item.data = "";
    item.showUploadBtn = false;

    item.flag = true;
  }

  uploadFile(item) {
    item.isUploading = true;
    const uploadData = new FormData();
    uploadData.append("file-to-be-uploaded", item.data);
    let challengeId = item.id;
    let param =
      "?CustomChallengeId=" +
      challengeId +
      "&region=" +
      item.region +
      "&category=" +
      this.selectedCategory;

    if (item.countryGroupId) {
      param = param + "&countryGroupId=" + item.countryGroupId;
    }
    this.sellerService.uploadAttachedDocument(uploadData, param).subscribe(
      (data) => {
        if (data.message) {
          item.flag = true;
          item.showUploadBtn = false;
          item.uploadSuccess = true;
          item.uploadFailure = false;
          item.name = item.data.name;
          item.data = "";
          item.isUploading = false;
          if (this.isStatic.name === "finalizeChallengePopup") {
            if (this.selectedCategory == "TERMS_AND_CONDITIONS") {
              var uploadedTerms = this.regionList.filter(
                (x) => x.category === "TERMS_AND_CONDITIONS"
              );
              if (uploadedTerms.find((x) => x.flag == false)) {
                this.uploadSubmitBtn = true;
              } else {
                this.uploadSubmitBtn = false;
              }
            }
          }
        }
      },
      (error) => {
        this.uploadSubmitBtn = true;
        item.flag = false;
        item.showUploadBtn = true;
        item.uploadSuccess = false;
        item.uploadFailure = true;
        item.isUploading = false;
      }
    );
  }
  // Upload terms and conditions
  submitUploadTerms() {
    // this.dialogRef.close();
    this.uploadSubmitBtn = true;
    let challengeId =
      this.isStatic.name === "finalizeChallengePopup"
        ? this.isStatic.data.id
        : this.isStatic.fileData.id;
    let params: any =
      "id=" + challengeId + "&status=" + "PENDING_FINAL_APPROVAL";
    this.managerService.submitForApproval(params).subscribe(
      (data) => {
        if (data != "") {
          this.uploadSubmitBtn = false;
          this.popupMessageService.showSuccess(
            "Uploaded Terms and condition successfully",
            "success",
            "salesChallengeToggleForm"
          );
          this.dialogRef.close({ uploadTerms: true });
        }
      },
      (error) => {
        // console.log(error)
      }
    );
  }
  categoryList: any = [];
  onChangeCategory(val) {
    this.regionList.forEach((region) => {
      let matched = false;

      for (let attachedFile of this.isStatic.fileData.attachedFiles) {
        if (attachedFile.category !== region.category) {
          continue;
        }

        // First priority: Match by category AND countryGroup ID
        if (
          attachedFile.countryGroup &&
          attachedFile.countryGroup.id === region.countryGroupId
        ) {
          region.name = attachedFile.name;
          region.noAttachment = false;
          region.data = { url: attachedFile.url };
          matched = true;
          break; // Found the most specific match, no need to continue
        }

        // Second priority: Match by category + region
        // BUT only if region.countryGroupId is not set
        if (
          !matched &&
          !region.countryGroupId && // ✅ Important: only fallback if no CG defined
          attachedFile.region === region.region
        ) {
          region.name = attachedFile.name;
          region.noAttachment = false;
          region.data = { url: attachedFile.url };
          matched = true;
          // Do not break here, in case a better match comes later (optional)
        }
      }

      // If still not matched, set "File Not Found"
      if (!matched) {
        region.name = "File Not Found";
        region.noAttachment = true;
        region.data = null;
      }
    });
  }

  // resend approval link
  resendEmailApprovalSpinner: boolean = false;
  approvalType: any;
  resendApprovalLink(val) {
    this.approvalType = val.type;
    this.resendEmailApprovalSpinner = true;
    const dialogRef = this.dialog.open(ApprovaltrackerDialogComponent, {
      width: "514px",
      data: { name: "resendApprovalData", data: val },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        setTimeout(() => {
          this.resendEmailApprovalSpinner = false;
        }, 1000);

        this.dialogRef.close({ approvals: result });
      } else {
        this.resendEmailApprovalSpinner = false;
      }
    });
  }
  sendApprovalLink(type) {
    let approvaltype = type;
    let reqParam =
      "customChallengeId=" +
      this.isStatic.data.id +
      "&approvalType=" +
      approvaltype;
    this.sellerService.resendApprovalLink(reqParam).subscribe((data) => {
      this.dialogRef.close({ approvals: data });
      this.popupMessageService.showSuccess(
        "Approval Link sent successfully",
        "success"
      );
    });
    this.dialogRef.close();
  }
  //submit for approval from draft to pending for approval
  submitForApproval() {
    this.dialogRef.close({ flag: true });
  }
  OnClosePopup() {
    this.dialogRef.close({ uploadTerms: true });
  }
  onChangeTermsandCondition(item) {
    this.selectedCategory = item.value;
    // this.regionList=[];

    //item.value!='TERMS_AND_CONDITIONS'?this.uploadSubmitBtn=false:this.uploadSubmitBtn=true;
    if (this.isStatic.name === "finalizeChallengePopup") {
      let termsCategory = this.regionList.filter(
        (x) => x.category === "TERMS_AND_CONDITIONS"
      );
      if (termsCategory.find((x) => x.flag == false)) {
        this.uploadSubmitBtn = true;
      }
    }
  }
  // approvaltracker table data
  approvalTrackerData = new MatTableDataSource();
  approvalColumnList: string[] = [
    "type",
    "status",
    "updatedOn",
    "action",
    "expandrow",
  ];
  approvalInnerColumList: string[] = ["email", "status", "respondedOn"];
  getApprovalTrackerData() {
    if (this.isStatic.name === "approvalTracker") {
      this.approvalTrackerData.data = this.isStatic.data;
    }
  }
  // on click on expand icon toggle icons
  selectedElementStatus;
  open(element) {
    //this.selectedElementStatus = element.status;
    element.isExpanded = !element.isExpanded;
    // if(!element.isExpanded) {
    //   // this.selectedElementStatus = element.status;
    //   // element.isExpanded = !element.isExpanded;
    //   //this.showLoader = true;
    //   // this.sellerService.getChallengeDetails(element.id).subscribe(
    //   //   (data) => {
    //   //     this.showLoader = false;
    //   //     this.challengeData = data;
    //   //   },
    //   //   (err) => {
    //   //     this.showLoader = false;
    //   //   }
    //   // );
    // } else {
    //   element.isExpanded = !element.isExpanded;
    // }
  }
  // comparing current date with expiry date
  currentDate = new Date();
  compareDate(val) {
    if (val != "") {
      let elementDate = new Date(val);
      if (this.currentDate < elementDate) {
        return "EXPIRES ON";
      } else {
        return "EXPIRED ON";
      }
    }
  }
  closeDialog() {
    this.dialogRef.close(false);
  }
  downloadAttachment(data) {
    window.open(data.url, "_blank").focus();
  }
  loadCiscoStyles(styleName) {
    const head = this.document.getElementsByTagName("head")[0];
    const styleLink = this.document.createElement("link");
    styleLink.rel = "stylesheet";
    styleLink.classList.add("cisco_styles");
    styleLink.href = styleName;
    head.appendChild(styleLink);
  }
  ngOnDestroy(): void {
    // let ciscoLinkElement = document.head.querySelector(`link[rel="stylesheet"].${'cisco_styles'}`);
    // if (ciscoLinkElement) {
    //   document.head.removeChild(ciscoLinkElement);
    // };
  }

  getUploadDoc(eve) {
    this.uploadedResult = [];
    this.uploadProgressFlag = true;
    if (this.dndFlag) {
      this.uploadedDocmentName = eve[0];
    } else {
      this.uploadedDocmentName = eve.target.files[0];
    }
    setTimeout(() => {
      this.uploadCompletions();
    }, 1000);
  }
  uploadCompletions() {
    const uploadData = new FormData();
    uploadData.append("excelFile", this.uploadedDocmentName);
    const param =
      "?activityChallengeId=" +
      this.isStatic.challengeData.id +
      "&youSure=true";
    this.sellerService.uploadCompletion(uploadData, param).subscribe((res) => {
      if (res) {
        this.uploadProgressFlag = true;
        this.uploadedResult.push(res);
      }
    });
  }
  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return "0 Bytes";
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }
  files: any[] = [];
  dndFlag: boolean = false;
  /**
   * on file drop handler
   */
  onFileDropped($event) {
    this.dndFlag = true;
    this.getUploadDoc($event);
  }
  showDownloadExcelFormatDialog() {
    const dialogRef = this.dialog.open(DownloadFileFormatDialog, {
      width: "514px",
      data: "UPLOAD_COMPLETION",
    });
    dialogRef.afterClosed().subscribe((result) => {
      // if (result.event) {
      // } else {
      // }
    });
  }
  getStatusHistoryOfCashPayments() {
    this.loadStatusHistroy = true;
    let req =
      "companyId=" +
      this.userProfile.company.id +
      "&cashPaymentId=" +
      this.isStatic.content.cashPaymentId;
    this.cashPaymentService
      .getStatusHistoryOfConsolidatedCashpaymentData(req)
      .subscribe(
        (response) => {
          this.loadStatusHistroy = false;
          if (response) {
            this.statusHistoryList = response;
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }
  confirmPayment() {
    let req = {
      companyId: this.userProfile.company.id,
      cashPaymentId: this.isStatic.content.cashPaymentId,
      proofOfPaymentSignature: this.signatureName,
    };

    this.cashPaymentService.submitProofOfPayment(req).subscribe(
      (response) => {
        if (response) {
          this.popupMessageService.showSuccess(response.msg, "success");
          this.dialogRef.close(true);
        }
      },
      (error) => {
        if (error.message) {
          this.popupMessageService.showError(error.message, "error");
        }
      }
    );
  }

  loading: string | null = null;

  generateFile(list) {
    this.loading = list.key;
    const id = list.id;

    let req = "customChallengeId=" + id + "&region=" + list.region;

    if (list.countryGroupId) {
      req = req + "&countryGroupId=" + list.countryGroupId;
    }

    let url = "";

    if (list.category === "TERMS_AND_CONDITIONS") {
      url = managerApi.generateTandConditionsFile + req;
    } else if (list.category === "ELIGIBLE_PRODUCT_LIST") {
      url = managerApi.generateEligProductsDocumentationAsDownloadable + req;
    }

    this.fileService.downloadFile(url).subscribe({
      next: () => {
        this.loading = null;
      },
      error: (err) => {
        console.error("Download failed", err);
        this.loading = null;
      },
    });
  }
  generateRegionUploadList(
    categories: any[],
    regions: string[],
    countryGroupList: any,
    data: { id: string; startDate: string }
  ): any[] {
    const regionList: any[] = [];
    const targetDate = new Date("2025-10-25");
    categories.forEach((category) => {
      regions.forEach((region) => {
        const normalizedDateStr = data.startDate.replace(/\+0000$/, "Z");
        const startDate = new Date(normalizedDateStr);

        const hasCountryGroups =
          startDate > targetDate &&
          Array.isArray(countryGroupList[region]) &&
          countryGroupList[region].length > 0;

        if (hasCountryGroups) {
          countryGroupList[region].forEach((countryGroup: any) => {
            regionList.push({
              key: region + countryGroup.id,
              id: data.id,
              region: region,
              countryGroupId: countryGroup.id,
              countryGroupName: countryGroup.name,
              category: category.value,
              data: "",
              flag: false,
              showUploadBtn: false,
            });
          });
        } else {
          regionList.push({
            key: region,
            id: data.id,
            region: region,
            category: category.value,
            data: "",
            flag: false,
            showUploadBtn: false,
            name: "", // Optional, if needed
          });
        }
      });
    });

    return regionList;
  }
}
